class ApiCallExecutorBase<T> {
    private pointerToComponent: T;

    public constructor(pointerToComponent) {
        this.pointerToComponent = pointerToComponent;
    }
}

export default ApiCallExecutorBase;